jQuery(function($) {
  $(document).ready(function() {
    initPopup();
  });

  function initPopup() {
    var config      = window.popupConfig || {};
    var popupKey    = config.popupKey    || 'announcement-popup';
    var closeCookie = Cookies.get(popupKey);
    var modalSource = '#ba-announcement-popup';

    console.log('popupConfig', config);
    console.log('magnific', $.magnificPopup);
    console.log('cookies', Cookies);

    if (!config.test && (closeCookie || !$(modalSource)[0])) {
      console.log('popupDisabled', closeCookie);
      return;
    }

    console.log('no closeCookie');

    modalSource

    setTimeout(function () {
      $.magnificPopup.open({
        removalDelay: 0,
        closeBtnInside: true,
        showCloseBtn: true,
        overflowY: 'scroll',
        closeOnBgClick: config.bgClose,
        callbacks: {
          close: function() {
            if (config.bgCookie) {
              Cookies.set(popupKey, 'true');
            }
          },
          open: function () {
            $('.mfp-close').off('click', closeCallback).on('click', closeCallback);

            function closeCallback() {
              Cookies.set(popupKey, 'true');
            }

            if (config.ctaCookie) {
              $('.baap-cta a').click(function() {
                Cookies.set(popupKey, 'true');
              });
            }
          }
        },
        items: {
          src: modalSource
        },
        type: 'inline'
      });
    }, 750);
  }
});

/*
$('elem').magnificPopup({

  type: 'inline',
  items: {
    src: $('.fl-button-lightbox-content')[0]
  },
  callbacks: {
    open: function() {
      var divWrap = $( $(this.content)[0] ).find('> div');
      divWrap.css('display', 'block');

      // Triggers select change in we have multiple forms in a page
      if ( divWrap.find('form select').length > 0 ) {
        divWrap.find('form select').trigger('change');
      }
    },
  },

  closeBtnInside: true,
  tLoading: '<i class="fas fa-spinner fa-spin fa-3x fa-fw"></i>',
});


*/

jQuery(function($)
{
  function InitializeHistorySlides(){
    $('.content-slides').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      infinite: false,
      speed: 300,
      cssEase: 'linear'
    });

    $('.content-slider .dot-wrapper').on('click', function(e){
      $('.content-slider').find('.dot-active').removeClass('dot-active');

      var curr_dot = this.id.split('_').slice(-1)[0]; //id="dot_#"" . Split on underscore, then get the last split
      $('.content-slides').slick('slickGoTo',curr_dot);

      $(this).children('.dot').addClass('dot-active');
    });
  }

  InitializeHistorySlides();
});

jQuery(function($)
{

});

jQuery(function($){
    /*** INIT ***/
    $(document).ready(function(){
        // Change flex proportions based on the number of items in the menu
        $('.main-menu--left-menu').css( 'flex-grow' ,$('.main-menu--left-menu .menu').children().length);
        $('.main-menu--right-menu').css( 'flex-grow' ,$('.main-menu--right-menu .menu').children().length);

        // If submenus go off screen, pull them back in
        $('.main-menu--container .menu > .menu-item').each(function(){
            adjustSubMenus(this);
        });
    });

    $(window).resize(function(){
        // If submenus go off screen, pull them back in
        $('.main-menu--container .menu > .menu-item').each(function(){
            adjustSubMenus(this);
        });
    });

    function adjustSubMenus( target ){
        var position = $(target).offset().left + 461;
        var max = $(document).outerWidth();
        if(position > max){
            $(target).find('.sub-menu').css('right','0');
        }else{
            $(target).find('.sub-menu').css('right','unset');
        }
    }

    /*** CLICKS ***/
    $(document).click(function(event) {
        //Remove class from all menu items
        $('.main-menu--container .menu > .menu-item').removeClass('active');

        if ( $(event.target).hasClass("menu-item") ) {
            //If you clicked a menu item, add class to that item
            $(event.target).toggleClass('active');
        } else if( $(event.target).parent().hasClass("menu-item") && $(event.target).parent().find('.sub-menu').length>0) {
            //Otherwise, if you clicked inside a menu item, add class to that menu item
            // console.log();
            // event.preventDefault();
            // $(event.target).parent().toggleClass('active');
        }
    });

    $('.main-menu--container .menu > .menu-item').on('focus', function(){
        //Remove class from all menu items
        $('.main-menu--container .menu > .menu-item').removeClass('active');
        $(this).toggleClass('active');
    });
});

jQuery(function($){
  // $('.pick-a-date_picker').datepicker();

  // Set Datepicker - https://stackoverflow.com/questions/38399337/force-jquery-ui-datepicker-to-display-below-input-field
	$('.pick-a-date_picker').datepicker({
      beforeShow: function (input, inst) {
          setTimeout(function () {
              inst.dpDiv.css({
                  top: $('.pick-a-date_picker').offset().top + 35,
                  right: $('.pick-a-date_picker').offset().right
              });
          }, 0);
      }
  });

  $('.pick-a-date_picker').on('change',function(){
    var curr_url = window.location.href;
    var params = new Array();
    if(curr_url.indexOf("?")>-1){
      params = curr_url.split("?")[1].split('&');
    }

    if(curr_url.indexOf("/page")>-1){
      curr_url = curr_url.split("/page")[0];
    }
    if(curr_url.indexOf("#")>-1){
      curr_url = curr_url.split("#")[0];
    }

    var i;
    for (i = 0; i < params.length; ++i) {
      if(params[i].substring(0, 4) == 'date'){params.splice(i,1);}
    }

    // if(date_param != ''){
    try{
      input_date = this.value.split('/');
      new_param = 'date=' + input_date[2] + '-' + input_date[0] + '-' + input_date[1]

      params.push(new_param);
      window.location = curr_url.split("?")[0] + '?' + params.join('&');
    }catch(e){
      console.log("Couldn't set new parameters:" + e);
    }
    //
    //   console.log();
    //   // new_param = 'date='
    //
    //   console.log(window.location.href.split("?")[0] + '?' + window.location.href.split("?")[1].replace(new RegExp(date_param), "replacement"));
    //     // window.location = window.location.href.split("?")[0] + '?' + window.location.href.split("?")[1].replace(/date_param/g, "date=");
    // }

  });
});

jQuery(function($){

    /*** CLICKS ***/
    $(document).on('click', function(event) { 

        /* Finding the right .quick-roster element */
        var clicked_element = false;
        if ($(event.target).hasClass("quick-roster")){
          clicked_element = $(event.target);
        }
        else if ($(event.target).parents(".quick-roster").length) {
          //Cancel this toggle if click is inside scroller
          if($(event.target).parents('.quick-roster_scroller').length){return;}
          clicked_element = $(event.target).parents(".quick-roster");
        }

        /* Setting it's .active class */
        if(clicked_element && clicked_element.hasClass('active')){
          clicked_element.toggleClass('active').find('.quick-roster_card').height(0);
          // console.log('Something');
          // clicked_element.scrollHeight - 79
          // $(clicked_element).find('.quick-roster_card').height($(clicked_element).find('.quick-roster_card')[0].scrollHeight);
          // console.log($(clicked_element).scrollHeight());
        } else if (clicked_element){
          $('.quick-roster.active').removeClass('active').find('.quick-roster_card').height(0);
          clicked_element.toggleClass('active').find('.quick-roster_card').height($(clicked_element).find('.quick-roster_card')[0].scrollHeight);
        } else{
          $('.quick-roster.active').removeClass('active').find('.quick-roster_card').height(0);
        }
    });
});

// jQuery(function($){
//   $('.calendar div.calendar_box').each(function(){
//     $(this).find('.list-card_media a').on('click',function(e){
//       e.preventDefault();
//       //Detail Pane
//       var detail_pane = $('.calendar div.calendar_box[data-list-card-id='+$(this).attr('data-list-card-id')+']').find('.list-card_details');
//       if(detail_pane){
//         if(!detail_pane.hasClass('open')){
//           $('.list-card_details').removeClass('open');
//           detail_pane.addClass('open');
//         }else{
//           detail_pane.removeClass('open');
//         }
//       }
//
//       //Reminder Pane
//       var reminder_pane = $('.calendar div.calendar_box[data-list-card-id='+$(this).attr('data-list-card-id')+']').find('.list-card_reminder');
//       if(reminder_pane){
//         if(!reminder_pane.hasClass('open')){
//           $('.list-card_reminder').removeClass('open');
//           reminder_pane.addClass('open');
//         }else{
//           reminder_pane.removeClass('open');
//         }
//       }
//
//     });
//   });
// });

jQuery(function($)
{
  function InitializeHistorySlides(){
    $('.testimonial-slides').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      infinite: false,
      speed: 300,
      cssEase: 'linear'
    });

    $('.testimonial-slider .dot-wrapper').on('click', function(e){
      $('.testimonial-slider').find('.dot-active').removeClass('dot-active');

      var curr_dot = this.id.split('_').slice(-1)[0]; //id="dot_#"" . Split on underscore, then get the last split
      $('.testimonial-slides').slick('slickGoTo',curr_dot);

      $(this).children('.dot').addClass('dot-active');
    });
  }

  InitializeHistorySlides();
});
